module.exports = __webpack_public_path__ + "assets/img/bg_blue.0dfb03c3.png";